/** @typedef {import ('./constants').SecureScoreProfileType} SecureScoreProfileType */

/**
 * Function to convert a string to constant case (e.g., 'myVariableName' to 'MY_VARIABLE_NAME')
 * @param {string} str - The string to convert
 */
const toConstantCase = (str) =>
  str.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toUpperCase();

/** Function to convert secure score profile types to constant cases
 * @returns {Record<Uppercase<SecureScoreProfileType>, SecureScoreProfileType>}
 */
export const convertSecureScoreProfileTypesToConstantCases = (
  secureScoreProfileTypes
) => {
  /** @type {Record<string, SecureScoreProfileType>} */
  const result = {};

  secureScoreProfileTypes.forEach((key, index) => {
    if (key) {
      result[toConstantCase(key)] = secureScoreProfileTypes[index];
    }
  });

  return result;
};

/** Function to add secure score profile types with an index starting from a given number
 * @param {number} startIndex - The index to start from
 * @return {Record<number, SecureScoreProfileType>}
 */
export const getSecureScoreProfileTypesWithIndex = (
  startIndex,
  secureScoreProfileTypes
) => {
  /** @type {Record<number, SecureScoreProfileType>} */
  const typesWithIndex = {};

  secureScoreProfileTypes.forEach((key, index) => {
    if (key) {
      typesWithIndex[startIndex + index] = secureScoreProfileTypes[index];
    }
  });

  return typesWithIndex;
};

export const deserializeCompliance = (str, COMPLIANCE_TYPES) =>
  Object.fromEntries(
    str.split("|").flatMap((part) => {
      const [name, valuesStr] = part.split(":");

      if (!COMPLIANCE_TYPES?.[name]) {
        // console.log(`Not found: ${name} in COMPLIANCE_TYPES object`);
        return [];
      }

      const values = valuesStr
        .split(",")
        .map((v) => v.trim().replace(/^'|'$/g, ""));

      return [[COMPLIANCE_TYPES[name], values]];
    })
  );
